import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RootBox = styled(Box)(() => ({
  display: 'flex',
  backgroundColor: '#F4F7FE',
  width: '100%',
}));
